import T from 'prop-types'

function Row({ label, isSelected = false, children }) {
  return (
    <div className="font-['Helvetica'] w-fit max-h-[50px] flex items-center rounded hover:bg-[#f5f5f5] gap-1 my-2">
      <div className="font-bold w-[35px] text-center text-gray-400">{label}</div>
      {children}
      <div className="w-[35px] flex-none" />
    </div>
  )
}

Row.propTypes = {
  label: T.oneOfType([T.string, T.number]).isRequired,
  isSelected: T.bool,
  children: T.arrayOf(T.element),
}

export default Row
